function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25 22.1802V15.7867C25 8.72473 30.7249 2.99985 37.7869 2.99985V2.99985",
  stroke: "#D6EDAA",
  strokeWidth: 6,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22 29C22 30.6569 23.3431 32 25 32H37C38.6569 32 40 30.6569 40 29V18C40 16.3431 38.6569 15 37 15H22V29Z",
  fill: "#D6EDAA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3 22.1802V15.7867C3 8.72473 8.72488 2.99985 15.7869 2.99985V2.99985",
  stroke: "#D6EDAA",
  strokeWidth: 6,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 29C0 30.6569 1.34315 32 3 32H15C16.6569 32 18 30.6569 18 29V18C18 16.3431 16.6569 15 15 15H0V29Z",
  fill: "#D6EDAA"
});

var SvgQuotes = function SvgQuotes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuotes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quotes.fa15af02.svg";
export { ForwardRef as ReactComponent };